module.exports = __webpack_public_path__ + "media/images/emblems/Uitikon-blazon-c7364eba87e3075b99f5efa1f6a51044.svg";